<template>
  <div v-if="loaded" class="app__wrap">
      <main class="app-content">
        <app-bar @toggleAi="toggleAiVisibility"></app-bar>
        <transition name="fade" mode="out-in">
          <router-view class="page-content"></router-view>
        </transition>
        <footer-bar></footer-bar>
        <ai-agent-button v-if="showAiAgent" />
      </main>
  </div>
</template>

<script setup>
  import {onMounted, ref, defineExpose} from 'vue';
  import { useRoute } from 'vue-router';
  import store from './vuex';
  import 'solana-wallets-vue/styles.css'
  import AppBar from './components/AppBar';
  import FooterBar from './components/FooterBar';
  import AiAgentButton from './components/ai/AiAgentButton';
  // import BasicPage from './pages/BasicPage'
  import {
    // LedgerWalletAdapter,
    PhantomWalletAdapter,
    // SlopeWalletAdapter,
    // TorusWalletAdapter,
  } from '@solana/wallet-adapter-wallets';
  import { initWallet } from 'solana-wallets-vue';

  const route = useRoute()

  const wallets = [
    new PhantomWalletAdapter(),
    // new SlopeWalletAdapter(),
    // new TorusWalletAdapter(),
    // new LedgerWalletAdapter(),
  ];

  initWallet({ wallets, autoConnect: store.state.autoConnect});

  const loaded = ref(false);
  const showAiAgent = ref(true) // Default to true
  const pageScrollPosition = ref(0);
  
  onMounted(() => {
    loaded.value = true;
    const aiEnabled = localStorage.getItem('bitcat_ai_enabled')
    showAiAgent.value = aiEnabled === null ? true : aiEnabled === 'true'
    window.addEventListener('scroll', setPageScrollPosition);
    window.addEventListener("beforeunload", handleBeforeUnload);
  })

  function handleBeforeUnload() {
    if(window.solana) {
      window.solana.disconnect()
    }
  }

  function setPageScrollPosition() {
    pageScrollPosition.value = window.scrollY;
  }

  const toggleAiVisibility = (value) => {
    showAiAgent.value = value
    localStorage.setItem('bitcat_ai_enabled', value.toString())
  }

  defineExpose({
    toggleAiVisibility
  })

  console.log('Welcome to BITCAT Universe dApp! Enjoy =)');
</script>

<style>
  html {
    flex: auto;
    display: flex;
    flex-direction: column;
    min-height: 100%;
  }

  body {
    flex: 1;
    display: flex;
    font-size: 16px;
    font-weight: 500;
    letter-spacing: .05em;
    font-family: 'Sour Gummy', sans-serif;
  }

  button {
    font-family: 'Sour Gummy', sans-serif;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s ease;
  }

  .fade-enter-from,
  .fade-leave-to {
    opacity: 0;
  }

  #app {
    flex: 1;
    display: flex;
    margin: 0 auto;
    width: 100%;
    max-width: 1900px;
    background: #e38f00;
  }
  .app__wrap {
    flex: 1;
    display: flex;
    width: 100%;
  }
  .app-content {
    flex: 1;
    position: relative;
    width: 100%;
    max-width: 1900px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
  }

  .page-content {
    width: 100%;
    flex: 1;
    padding: 30px 2% 20px;
    background: #fff;
    /*z-index: 100;*/
    box-shadow: 0px 3px 5px -5px rgba(0, 0, 0, 0.25);
  }

  button.swv-button.swv-button-trigger {
    background-color: rgb(223, 84, 39);
  }

  button.swv-button.swv-button-trigger:hover {
    background-color: rgb(215, 77, 36);
  }
</style>
